// <test-component></test-component>; // false
// <test-component deletable></test-component>; // true
// <test-component deletable="true"></test-component>; // true
// <test-component deletable="false"></test-component>; // false
// <test-component :deletable="undefined"></test-component>; // false

export default {
  methods: {
    /**
     * @param {String} name
     * @returns {Boolean}
     */
    // <component @name>
    hasEvent(name) {
      if (this.$listeners[name]) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * @param {String} name
     * @returns {Boolean}
     */
    // <component name>
    hasAttribute(name) {
      if (this.$attrs[name] === "" || this.$attrs[name] === true || this.$attrs[name] === "true") {
        return true;
      } else {
        return false;
      }
    },
    parseAttr(key, options = {}) {
      const attr = this.$attrs[key];
      const defaultValue = options.default;

      if (!this.hasAttribute(key)) return defaultValue;
      else return attr;
    },
    //<component @onClick=""> or <component v-on:onClick="">
    parseVOnAttr(key, options = {}) {
      if (this.$listeners[key] === undefined) return options.default;
      if (this.$listeners[key]) return true;
      else return false;
    },
  },
};
